// Phase 3B.1 — pure placement rules for the persistent "Continue" pill.
//
// Extracted so the two production collisions found during validation
// (cookie banner overlap, mini-player overlap) are covered by tests.

export interface ContinueVisibilityInput {
  journeyLoading: boolean;
  dismissed: boolean;
  scrolled: boolean;
  /** Cookie banner still occupies the bottom of the viewport. */
  consentPending: boolean;
  pathname: string;
  mutedPrefixes: readonly string[];
}

export function shouldShowContinue(i: ContinueVisibilityInput): boolean {
  if (i.journeyLoading || i.dismissed || !i.scrolled || i.consentPending) return false;
  return !i.mutedPrefixes.some((p) => i.pathname.startsWith(p));
}

/** Raises the pill above the mini player's bottom rail while audio is active. */
export function continueOffsetClass(nowPlaying: boolean): string {
  return nowPlaying
    ? "bottom-[calc(10.5rem+env(safe-area-inset-bottom))] lg:bottom-[calc(6.5rem+env(safe-area-inset-bottom))]"
    : "bottom-[calc(5.5rem+env(safe-area-inset-bottom))] lg:bottom-6";
}
